import ApplicationAdapter from './application';
import DS from 'ember-data';
import { inject as service } from '@ember/service';
import AuthService from 'cio/services/auth';
import MasqService, { ADMIN_ACCOUNT_ID } from 'cio/services/masq';
import { ApiResponse } from 'cio/services/api';

const { InvalidError } = DS;

export default class UserAdapter extends ApplicationAdapter {
  @service auth!: AuthService;
  @service masq!: MasqService;

  handleResponse(status: number, headers: Record<string, any>, payload: ApiResponse, requestData: Record<string, any>) {
    if (status !== 409) {
      return super.handleResponse(status, headers, payload, requestData);
    }

    // turn 409 (conflict) response into generic invalid model error
    // 409 in case of users is caused by non-unique email - it can be turned into "email" attribute error
    payload.errors = [
      {
        detail: 'Email already taken.',
        source: { pointer: '/data/attributes/email' },
        status: '409',
      },
    ];
    return new InvalidError(payload.errors);
  }

  buildURL(_modelName: unknown, id: string) {
    let url = super.buildURL(...arguments);

    // consider that masqing user always belongs to admin CIO account ID=1, use it when building their resource URL
    if (this.masq.isOn && id === this.auth.user?.id) {
      url = url.replace(/accounts\/\d+/, `accounts/${ADMIN_ACCOUNT_ID}`);
    }

    return url;
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your adapters.
declare module 'ember-data/types/registries/adapter' {
  export default interface AdapterRegistry {
    user: UserAdapter;
  }
}
